import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-reusable-paginator',
  template: `
    <div class="paginator-container">
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [disabled]="isLoading"
        (page)="onPageChange($event)"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  `,
  styles: [
    `
      .paginator-container {
        position: relative;
      }
    `,
  ],
  standalone: true,
  imports: [MatPaginatorModule],
})
export class ReusablePaginatorComponent implements OnChanges {
  @Input() pageSizeOptions: number[] = [10, 25, 50];
  @Input() pageSize: number = 10;
  @Input() totalCount: number = 0;
  @Input() pageIndex: number = 0;
  @Input() isLoading: boolean = false;
  @Input() debugMode: boolean = true; // Enable by default for debugging
  @Output() pageChanged = new EventEmitter<PageEvent>();

  // Computed property to determine if there's a next page
  get hasNextPage(): boolean {
    return this.totalCount > (this.pageIndex + 1) * this.pageSize;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Log changes to key pagination properties for debugging

  }

  onPageChange(event: PageEvent) {
    this.pageChanged.emit(event);
  }
}
